
<div id='SubmissionSuccess' class='container-fluid mt-5'>
    <form name="SubmissionSuccess" #SubmissionSuccessForm="ngForm" novalidate>
        <div class="alert alert-danger" role="alert" *ngIf="validationMessages.length > 0">
			<div class="section vam-MB0">
      <h2>Please fix the following errors:</h2>
				<ul class="list-group vm-list-decimal">					
					<li class="list-group-item vm-list-decimal-item bg-transparent border-0" *ngFor="let error of validationMessages">{{ error }}</li>
				</ul>
			</div>
		</div>
        <div class="row">
            <div class='col-sm-12'>
                    
<div  id= "Block958de548fd93442d9ace2957188ce814"  ><div class='row  '  ><div   class='col-sm-12 ' ><span  title= "success"  id= "Icon65906c8a153f47599f73fa638c7f7a4b"  class= "material-symbols-outlined vm-icon    vm-element-textalign__center "  style= "font-weight:400; color:#62cf5d;font-variation-settings:'FILL' 0;font-size:100px" >check_circle</span> </div></div><div class='row  '  ><div   class='col-sm-12 d-flex justify-content-center align-items-center ' ><span  style= "font-size:25px; text-align:center"  id= "Inline57fc9e0c50b249fb90f72d656cb1ebce"  >Thank you for submitting the form. Order fulfillment process has been initiated. One of our representatives will reach out to you, if needed. </span></div></div> </div>
            </div>
        </div>
    </form>
</div>
